import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  printReportRequest,
  printReportSuccess,
  printReportFailure,
} from '../reducers/savedVersions';
import { authUserFailure } from '../reducers/login';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/printReport`;

function* printReportFunctionAxios() {
  const state = yield select(fullState => fullState);
  const userId = state.loginReducer.user.isTeamLeader
    ? state.teamMembersFullReducer.selectedTeamMemberId
    : state.loginReducer.user.userId;
  const { token } = state.loginReducer;
  const versionId = state.loginReducer.user.isTeamLeader
    ? state.teamMembersFullReducer.selectedVersionId
    : state.userProgramsFullReducer.selectedUserVersion;

  return yield call(() =>
    axios({
      method: 'post',
      url: API,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      data: {
        userId,
        versionId,
      },
    }),
  );
}

function* workerPrintReportSaga() {
  try {
    const response = yield call(printReportFunctionAxios);
    const responseFromPrintReport = response.data;

    if (response.status === 200) {
      yield put(printReportSuccess(responseFromPrintReport));
    }
    if (response.status === 500) {
      yield put(authUserFailure(response));
    }
  } catch (error) {
    yield put(printReportFailure(error.response));
  }
}

export function* watcherPrintReportSaga() {
  yield takeLatest(printReportRequest().type, workerPrintReportSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/post_printReport.js